/**
 * Created by han on 11/26/2018.
 */

import {
	$,
	// class
	addClass,
	removeClass,
	toggleClass,
	hasClass,
	// attr
	attr,
	removeAttr,
	// selector
	filter,
	find,
	each,
	closest,
	is,
	eq,
	parents,
	children,
	// event
	on,
	once,
	off,
	// animation
	css,
	animate,
	transform,
	transition,

	scrollTo,
	offset,
} from 'dom7/dist/dom7.modular';

const proto = {
	// class
	addClass,
	removeClass,
	toggleClass,
	hasClass,
	// attr
	attr,
	removeAttr,
	// selector
	filter,
	find,
	each,
	closest,
	is,
	eq,
	parents,
	children,
	// event
	on,
	once,
	off,
	// animation
	css,
	animate,
	transform,
	transition,

	scrollTo,
	offset,
};

Object.keys(proto).forEach(fn => {
	$.fn[fn] = proto[fn];
});

export default $;